export const MONTHS_SHORT = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
}

export const MILLIS_IN_A_MINUTE = 1000 * 60
export const MILLIS_IN_A_DAY = MILLIS_IN_A_MINUTE * 60 * 24

export const formatDate = dateString => {
  if (!dateString) return null
  let [year, month, date] = dateString.substr(0, 10).split('-')
  if (new Date().getFullYear() === Number(year)) {
    year = ''
  }
  let result = `${Number(date)} ${MONTHS_SHORT[Number(month - 1)]}`
  if (year) {
    result = `${result} ${year}`
  }
  return result
}

export const formatISOStringDate = dateString => {
  if (!dateString) return null
  const date = new Date(dateString)
  let year = date.getFullYear(),
    month = date.getMonth(),
    day = date.getDate()
  if (new Date().getFullYear() === Number(year)) {
    year = ''
  }
  return `${day} ${MONTHS_SHORT[month]} ${year}`
}

export const getDaysBetween = (date1, date2) => {
  date1.setHours(0, 0, 0, 0)
  date2.setHours(0, 0, 0, 0)
  const days = (date2.getTime() - date1.getTime()) / MILLIS_IN_A_DAY
  return Math.ceil(days)
}

export const getDaysAfter = date => {
  if (!date) return
  const age = getDaysBetween(new Date(date), new Date())
  const suffix = age > 1 ? 'days' : 'day'
  return `${age} ${suffix}`
}

/**
 * This convert input dateString (ISO) to relative day format. e.g Today, 2D, 3D, 1W, 1Y
 * This function is currently supposed to work with today and past dates only
 *
 * Test cases here - test/utils/formatDate.test.js
 * @param dateString
 * @returns {string|null}
 */
export const getRelativeDuration = dateString => {
  if (!dateString) return null
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return null
  const today = new Date()
  const daysDiff = Math.abs(getDaysBetween(date, today))
  if (daysDiff === 0 && date.getDate() === today.getDate()) return 'Today'
  else if (daysDiff < 14) return `${daysDiff}D`
  else if (daysDiff <= 30) return `${Math.floor(daysDiff / 7)}W`
  else if (daysDiff <= 365) return `${Math.floor(daysDiff / 30)}M`
  else return `${Math.floor(daysDiff / 365)}Y`
}

export const twoDigit = number => (number < 10 ? `0${number}` : number)

/**
 * This converts the input date object to date string in format YYYY-MM-DD
 */
export const convertToDateString = date => {
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  return `${year}-${twoDigit(month + 1)}-${twoDigit(day)}`
}

/**
 * This returns the time in am/pm format
 * @param dateString
 * @returns {string}
 */
export const getFormattedTime = dateString => {
  const date = new Date(dateString)
  let hours = date.getHours()
  const minutes = date.getMinutes()
  let meridian = 'am'
  if (hours > 12) {
    meridian = 'pm'
    if (hours > 13) {
      hours = hours - 12
    }
  }
  return `${twoDigit(hours)}:${twoDigit(minutes)}${meridian}`
}

/**
 * This parses the dateString into a readable format.
 * If date belongs to today, format that it returns is - 10:30am
 * else the format that it returns is - 22 Jan | 22 Dec 2019
 * @param dateString
 * @returns {string|null}
 */
export const getTimeOrDate = dateString => {
  const date = new Date(dateString)
  const time = getFormattedTime(dateString)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  if (today.getTime() === date.getTime()) {
    return time
  } else {
    return formatDate(dateString)
  }
}
